module.exports = __webpack_public_path__ + "static/media/jIsakson.2a2c3aba.jpeg";